import { Injectable } from '@angular/core';
import { ProductDiscount } from '../entities/product-discount';
import { BaseTableService } from './base-table.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@mobileia/authentication';
import { Observable } from 'rxjs';
import { ApiResponse, ApiPagination, MIATableModel } from '@mobileia/core';
import { Category } from '../entities/category';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductDiscountService extends BaseTableService<ProductDiscount> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/product-discount';
  }
  
}
